var fullpageItem = $('#fullpage');

if (fullpageItem.length) {

    new fullpage('#fullpage', {
        //options here
        licenseKey: '071A2FE1-C76E40EA-84FF7E85-A2BB2FD8',

        scrollOverflow: true,
        //scrollBar: true,
        responsiveWidth: 900,

        afterLoad: function(origin, destination, direction) {
            if(destination.index != 0) {
                $('.header').addClass('is-scrolled');
            } else {
                $('.header').removeClass('is-scrolled');
            }

            $('.js-anim').each(function () {
                if ($(this).isInViewport() === true && !$(this).hasClass('.js-anim--active')) {
                if($(this).hasClass('js-anim--children')) {
                    var animInterval = $(this).data('anim-interval') || 100;
                    var animDelay = $(this).data('anim-delay') || 0;
                    var that = this;
                    var delay = setTimeout(function() {
                    $(that).children().each(function(i) {
                        var interval = animInterval * i;
                        var target = this;
                        var t = setTimeout(function() {
                            $(target).addClass('js-anim--active');
                        }, interval);
                    });
                    }, animDelay);
                }
                else {
                    var animDelay = $(this).data('anim-delay') || 0;
                    var that = this;
                    var delay = setTimeout(function() {
                    $(that).addClass('js-anim--active');
                    }, animDelay);
                }
                }
            });
        }
    });
}
